// Lib
import React from 'react';
import loadable from 'react-loadable';

// Components
import LoadablePopupSpinner from '../../../../../components/popupPanel/LoadablePopupSpinner';

export default loadable({
    loader: () => import(/* webpackChunkName: "board-editor-popup-content" */ './BoardEditorsPopupContent'),
    loading: () => <LoadablePopupSpinner />,
});
